import Vue from 'vue'
import Router from 'vue-router'
// import * as firebase from 'firebase/app'
// import 'firebase/auth'
import firebase from 'firebase'
import Home from '@/components/HomeComponent.vue'
import Profile from '@/components/ProfileComponent'
import MyFuneral from '@/components/MyFuneralComponent'
import GuardiansMain from '@/components/GuardiansMainComponent'
import Guardians from '@/components/guardian/GuardiansComponent'
import Proteges from '@/components/guardian/ProtegesComponent'
import Contacts from '@/components/ContactsComponent'
import Invitations from '@/components/guardian/InvitationsComponent'
import Pets from '@/components/PetsComponent'
import Login from '@/components/LoginComponent'
import Signup from '@/components/SignupComponent'
import Burial from '@/components/funeral/BurialComponent'
import Ceremony from '@/components/funeral/CeremonyComponent'
import Guestlist from '@/components/funeral/GuestlistComponent'
import Speeches from '@/components/funeral/SpeechesComponent'
import RecoverPassword from '@/components/RecoverPasswordComponent'
import Links from '@/components/LinksComponent'
import Account from '@/components/AccountComponent'
import Documents from '@/components/DocumentsComponent'
import Photos from '@/components/PhotosComponent'

Vue.use(Router)

let router = new Router({
    routes: [
        {
            path: '*',
            redirect: '/login',
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/profile',
            component: Profile,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/my-funeral',
            component: MyFuneral,
            meta: {
                requiresAuth: true
            },
            redirect: '/my-funeral/burial',
            children: [
                {
                    path: 'burial',
                    component: Burial,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'ceremony',
                    component: Ceremony,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'guestlist',
                    component: Guestlist,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'speeches',
                    component: Speeches,
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            path: '/guardians',
            component: GuardiansMain,
            meta: {
                requiresAuth: true
            },
            redirect: '/guardians/guardians',
            children: [
                {
                    path: 'guardians',
                    component: Guardians,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'proteges',
                    component: Proteges,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'invitations',
                    component: Invitations,
                    meta: {
                        requiresAuth: true
                    }
                }
            ]
        },
        {
            path: '/contacts',
            component: Contacts,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/photos',
            component: Photos,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/documents',
            component: Documents,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pets',
            component: Pets,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/links',
            component: Links,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/account',
            component: Account,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/signup',
            component: Signup,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/recover-password',
            component: RecoverPassword,
            meta: {
                requiresAuth: false
            }
        }
    ],
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    let currentUser = firebase.auth().currentUser
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth && !currentUser) next('login')
    else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js